import { loadRecaptcha } from './load_recaptcha.js';
import { copyTextToClipboard } from '../modules/utilities';

export const shareModal = () => {
  const OPEN_CLASS = 'open';
  const shareModal = document.querySelector('.share-modal');
  const shareOverlay = document.querySelector('.share-modal-overlay');
  const shareBtn = document.querySelectorAll('.js-open-share-btn');
  const closeIcon = document.querySelector('.js-close-share-btn');
  const closeBtn = document.querySelector('.input-actions__close');
  const emailBtn = document.querySelector('.share-modal__actions-email');
  const linkBtn = document.querySelector('.share-modal__actions-link');
  const sendBtn = document.querySelector('.input-actions__send');
  const propertyIds = document.querySelector('[name="propertyIds"]');

  if (shareBtn) {

    shareBtn.forEach((elem, index) => {
      elem.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();

        if(!this.classList.contains('disabled')){
          loadRecaptcha();

          propertyIds.value = this.getAttribute('data-share');
          elem.classList.add(OPEN_CLASS);
          shareModal.classList.add(OPEN_CLASS);
          shareOverlay.classList.add(OPEN_CLASS);
          closeIcon.addEventListener('click', closeOverlay);
          closeBtn.addEventListener('click', closeOverlay);
          emailBtn.addEventListener('click', showEmail);
          linkBtn.addEventListener('click', showLink);
          sendBtn.addEventListener('click', sendEmail);


        };
      });
    });
  }

  if (sendBtn) {
    sendBtn.addEventListener('click', sendEmail);
  }

  function closeOverlay() {
    shareBtn.forEach((elem) => {
      elem.classList.remove(OPEN_CLASS);
    });

    shareModal.classList.remove(OPEN_CLASS);
    shareOverlay.classList.remove(OPEN_CLASS);

    var tabs = document.querySelectorAll('.share-modal__tab');
    tabs.forEach((elem, index) => {
      if (index == 0) {
        elem.classList.add('selected');
      } else {
        elem.classList.remove('selected');
      }
    });
    clearForm();
  }

  function showEmail() {
    showTab(this.getAttribute('data-view'));
  }

  function showLink() {
    copyLink();
    showTab(this.getAttribute('data-view'));
  }

  function showTab(tab) {
    var tabs = document.querySelectorAll('.share-modal__tab');

    tabs.forEach((elem, index) => {
      if (elem.classList.contains(tab)) {
        elem.classList.add('selected');
      } else {
        elem.classList.remove('selected');
      }
    });
  }

  function copyLink() {
    console.log('copyLink');
    const text = window.location.href;
    copyTextToClipboard(text);
  }

  function sendEmail() {
    var valid = true;
    var fName = document.querySelector('[name="first_name"]');
    var lName = document.querySelector('[name="last_name"]');
    var tAddress = document.querySelector('[name="send_to"]');
    var fAddress = document.querySelector('[name="send_from"]');
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    if (fName.value.length < 1) {
      valid = false;
      fName.classList.add('not-valid');
    } else {
      fName.classList.remove('not-valid');
    }

    if (lName.value.length < 1) {
      valid = false;
      lName.classList.add('not-valid');
    } else {
      lName.classList.remove('not-valid');
    }

    if (tAddress.value.length < 1) {
      valid = false;
      tAddress.classList.add('not-valid');
    } else if (!tAddress.value.match(mailformat)) {
      valid = false;
      tAddress.classList.add('not-valid');
    } else {
      tAddress.classList.remove('not-valid');
    }

    if (fAddress.value.length < 1) {
      valid = false;
      fAddress.classList.add('not-valid');
    } else if (!fAddress.value.match(mailformat)) {
      valid = false;
      fAddress.classList.add('not-valid');
    } else {
      fAddress.classList.remove('not-valid');
    }

    if (valid) {

      var data = {};
      data.firstName = fName.value.replace("&","and").replace("?",".").replace("//","|");
      data.lastName = lName.value.replace("&", "and").replace("?", ".").replace("//", "|");
      data.fromAddress = fAddress.value.replace("&", "and").replace("?", ".").replace("//", "|");
      data.toAddress = tAddress.value.replace("&", "and").replace("?", ".").replace("//", "|");
      data.message = document.querySelector('[name="send_message"]').value.replace("&", "and").replace("?", ".").replace("//", "|");
      data.shareUrl = window.location.href;
      data.propertyids = document.querySelector('[name="propertyIds"]').value;
      data.isPdp = document.querySelector('[name="isPdp"]').value;
      data.licenseNumber = document.querySelector('[name="licenseNumber"]').value;

      const recap = document.querySelector('.share-modal .g-recaptcha');

      if(recap){
        const reid = recap.getAttribute('data-reid');
        data.grecaptchaResponse = grecaptcha.getResponse(recaptchaIds[reid]);
      }

      console.log('data');
      console.log(data);

      console.log('shareModal.dataset.url');
      console.log(shareModal.dataset.url);

      if (shareModal.dataset.url) {
        $.ajax({
          url: shareModal.dataset.url,
          type: "POST",
          data: data
        }).then(function (x) {
          if (x) {
            closeOverlay();
          } else {
            //console.log('Endpoint returned: ' + x);
          }
        });
      }
    }
  };
  function clearForm() {
    document.querySelector('[name="send_message"]').value = "";
  }
};




// WEBPACK FOOTER //
// ./src/js/components/share-modal.js